import React from 'react'
import {
    UsersIcon,
    ProfileIcon,
    SecurityIcon,
    EmailIcon,
    TenantsIcon,
    IntegrationsIcon,
    KeyPairsIcon,
    ProjectsIcon,
} from '../components'
import Users from '../users/Users'
import UserProfile from '../users/UserProfile'
import UserSecurity from '../users/UserSecurity'
import UserForm from '../users/UserForm'
import VerifyEmail from '../auth/VerifyEmail'
import Tenants from '../tenants/Tenants'
import TenantForm from '../tenants/TenantForm'
import KeyPairs from '../keypairs/KeyPairs'
import KeyPairForm from '../keypairs/KeyPairForm'
import { RouteItem } from './RouteItem.types'

import Projects from '../projects/Projects'
import ProjectForm from '../projects/ProjectForm'
import ProjectViews from '../projectviews/ProjectViews'

export const routes = [
    {
        title: 'users.profile.title',
        path: '/profile',
        icon: <ProfileIcon />,
        component: UserProfile,
        hidden: true,
    },
    {
        title: 'auth.verify_email.title',
        path: '/verify-email/:code',
        icon: <EmailIcon />,
        component: VerifyEmail,
        hidden: true,
    },
    {
        title: 'users.security.title',
        path: '/security',
        icon: <SecurityIcon />,
        component: UserSecurity,
        hidden: true,
    },
    {
        title: 'users.title',
        path: '/tenants/:tenantId/users/new',
        icon: <UsersIcon />,
        component: UserForm,
        grants: ['UsersCreate'],
        hidden: true,
    },
    {
        title: 'users.title',
        path: '/tenants/:tenantId/users/:userId/edit',
        icon: <UsersIcon />,
        component: UserForm,
        grants: ['UsersUpdate'],
        hidden: true,
    },
    {
        title: 'users.title',
        path: '/tenants/:tenantId/users',
        icon: <UsersIcon />,
        component: Users,
        grants: ['UsersRead'],
        hidden: true,
    },
    {
        title: 'projects.title',
        path: '/tenants/:tenantId/projects/new',
        icon: <ProjectsIcon />,
        component: ProjectForm,
        grants: ['ProjectsCreate'],
        hidden: true,
    },
    {
        title: 'projects.title',
        path: '/tenants/:tenantId/projects/:projectId/edit',
        icon: <ProjectsIcon />,
        component: ProjectForm,
        grants: ['ProjectsUpdate'],
        hidden: true,
    },
    {
        title: 'projects.title',
        path: '/tenants/:tenantId/projects/:projectId/views',
        icon: <ProjectsIcon />,
        component: ProjectViews,
        grants: ['ProjectsRead'],
        hidden: true,
    },
    {
        title: 'projects.title',
        path: '/tenants/:tenantId/projects',
        icon: <ProjectsIcon />,
        component: Projects,
        grants: ['ProjectsRead'],
        hidden: true,
    },
    {
        title: 'tenants.new_tenant',
        path: '/tenants/:tenantId/edit',
        icon: <TenantsIcon />,
        component: TenantForm,
        grants: ['TenantsUpdate'],
        hidden: true,
    },
    {
        title: 'tenants.new_tenant',
        path: '/tenants/new',
        icon: <TenantsIcon />,
        component: TenantForm,
        grants: ['TenantsCreate'],
        hidden: true,
    },
    {
        title: 'tenants.title',
        path: '/tenants',
        icon: <TenantsIcon />,
        component: Tenants,
        grants: ['TenantsRead'],
    },
    {
        title: 'users.title',
        path: '/users/new',
        icon: <UsersIcon />,
        component: UserForm,
        grants: ['UsersCreate', 'TenantsUsersCreate'],
        hidden: true,
    },
    {
        title: 'users.title',
        path: '/users/:userId/edit',
        icon: <UsersIcon />,
        component: UserForm,
        grants: ['UsersUpdate', 'TenantsUsersUpdate'],
        hidden: true,
    },
    {
        title: 'users.title',
        path: '/users',
        icon: <UsersIcon />,
        component: Users,
        grants: ['UsersRead', 'TenantsUsersRead'],
    },
    {
        title: 'projects.title',
        path: '/projects/new',
        icon: <ProjectsIcon />,
        component: ProjectForm,
        grants: ['TProjectsCreate'],
        hidden: true,
    },
    {
        title: 'projects.title',
        path: '/projects/:projectId/edit',
        icon: <ProjectsIcon />,
        component: ProjectForm,
        grants: ['TProjectsUpdate'],
        hidden: true,
    },
    {
        title: 'projects.title',
        path: '/projects/:projectId/views',
        icon: <ProjectsIcon />,
        component: ProjectViews,
        grants: ['TProjectsRead'],
        hidden: true,
    },
    {
        title: 'projects.title',
        path: '/projects',
        icon: <ProjectsIcon />,
        component: Projects,
        grants: ['TProjectsRead'],
    },
    {
        title: 'integrations.title',
        path: '',
        icon: <IntegrationsIcon />,
        grants: ['X'],
        items: [
            {
                title: 'keypairs.title',
                path: '/keypairs/new',
                icon: <KeyPairsIcon />,
                component: KeyPairForm,
                grants: ['KeyPairsCreate'],
                hidden: true,
            },
            {
                title: 'keypairs.title',
                path: '/keypairs/:keyPairId',
                icon: <KeyPairsIcon />,
                component: KeyPairForm,
                grants: ['KeyPairsUpdate'],
                hidden: true,
            },
            {
                title: 'keypairs.title',
                path: '/keypairs',
                icon: <KeyPairsIcon />,
                component: KeyPairs,
                grants: ['KeyPairsRead'],
            },
        ],
    },
] as RouteItem[]
